module.exports = __webpack_public_path__ + "img/2f_r_fukumitsu_2@2x.651b6bd3.png";